var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-actions"},_vm._l((_vm.data.filter(v => !v.show || v.show(_vm.row))),function(item){return _c('span',{key:item.key,on:{"click":function($event){return _vm.$emit('table-action', {action: item.key, data: _vm.row, index: _vm.index})}}},[_vm._v(_vm._s(item.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }